import { Typography } from "@c4c-web/ui";
import { HouseIcon, OfficeIcon, PinIcon } from "@c4c-web/icons";
import {
  countryCodeShaper,
  filterAddressParts,
  phoneNumberShaper,
} from "../../../utils";
import type { IUserAddress } from "../../../types";
import { EAddressType } from "../../../constants";
import type { IOption } from "./delivery-location-sheet.interface";
import { getAddressStatus } from "./delivery-location-sheet.helper";

export const getAddressTypeIcon = (addressLabel: string): JSX.Element => {
  switch (addressLabel.toLowerCase()) {
    case EAddressType.HOME as unknown as string:
      return <HouseIcon variant="thin" />;
    case EAddressType.OFFICE as unknown as string:
      return <OfficeIcon variant="thin" />;
    default:
      return <PinIcon variant="thin" />;
  }
};

export const GenerateAddressOptions = (
  addresses: IUserAddress[],
): IOption[] => {
  return addresses.map((address) => {
    const {
      addressLabel,
      appartment,
      building,
      emirate,
      phone,
      streetName,
      town,
    } = address;

    const primaryAddressParts = filterAddressParts([
      building,
      appartment || addressLabel || "",
    ]);

    const secondaryAddressParts = filterAddressParts([
      streetName,
      town,
      emirate || "",
    ]);

    return {
      value: address.id,
      label: (
        <div className="flex items-center gap-xs">
          <div>{getAddressTypeIcon(addressLabel || "home")}</div>
          <div className="flex flex-col text-start">
            <Typography variant="lg" weight="bold">
              {Array.isArray(primaryAddressParts)
                ? primaryAddressParts.join(" - ")
                : primaryAddressParts}
            </Typography>

            <Typography variant="md">
              {Array.isArray(secondaryAddressParts) &&
              secondaryAddressParts.length > 1 ? (
                <>
                  {secondaryAddressParts[0]}
                  <br />
                  {secondaryAddressParts.slice(1).join(", ")}
                </>
              ) : (
                secondaryAddressParts
              )}
            </Typography>

            {phone ? (
              <Typography variant="md">
                {countryCodeShaper(phone)} {phoneNumberShaper(phone)}
              </Typography>
            ) : null}
          </div>
        </div>
      ),
      status: getAddressStatus(address),
    };
  });
};
